import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

// Configuração do Firebase
const firebaseConfig = {
  apiKey: "AIzaSyA63AVsJjM10WiU2reMGEpHa_vp4Bqj1Ao",
  authDomain: "escolar-ce5fb.firebaseapp.com",
  projectId: "escolar-ce5fb",
  storageBucket: "escolar-ce5fb.firebasestorage.app",
  messagingSenderId: "555592247763",
  appId: "1:555592247763:web:4e540676b8bc234838a726"
}

// Inicializar Firebase
const app = initializeApp(firebaseConfig)

// Inicializar serviços
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)

export default app